import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-col pb-3" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex justify-end gap-3 pt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Field, {
            field_name: "Sconto in percentuale",
            modelValue: _ctx.scontoModel,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scontoModel) = $event)),
            placeholder: "Sconto",
            type: "number",
            "input-attrs": {step:0.01,min:0, max:100},
            errors: [_ctx.error]
          }, null, 8, ["modelValue", "errors"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_NextButton, {
        variant: "outline-secondary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('chiudi'))),
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode(" Chiudi ")
        ])),
        _: 1
      }),
      _createVNode(_component_NextButton, {
        variant: "primary",
        disabled: _ctx.$attrs.waiting,
        onClick: _ctx.save,
        class: "w-44 py-2 px-4"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode(" Salva ")
        ])),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}